export enum ResourceTypes {
	IMAGE = 'IMAGE',
	HTML = 'HTML',
	NATIVE = 'NATIVE',
	VIDEO = 'VIDEO',
}
